import store from '@/store/store'
import router from '@/router'
import { http } from '@/plugins/http'
import { ElNotification } from 'element-plus'

// Module-level debounce: at most one "session expired" notification per 10s window (was `Vue.prototype.$unauthorizedNotif`).
let unauthorizedNotifActive = false

/**
 * Checks for a 401 Unauthorized response from the API, and if found, displays an error message and prompts
 * the user to reauthenticate.
 *
 * CP (Vue 3): registers on the adapter's own `http.interceptors` (imported from src/plugins/http) instead of
 * `Vue.http.interceptors` — `app.use()` passes the app, which has no `.http`, so the old reference threw. Notify
 * uses element-plus `ElNotification` directly rather than the global `Vue.prototype.$notify`.
 */
export default {
  install () {
    http.interceptors.push((request, next) => {
      next((response) => {
        if (response && String(response.status) === '401') {
          store.dispatch('setReauthRequired', true)
          store.dispatch('setPostAuthorizationRoute', router.currentRoute.value.name)
          store.dispatch('changeModalVisibility', { entityType: 'reauthModal', visible: true })
          if (!unauthorizedNotifActive) {
            unauthorizedNotifActive = true
            ElNotification.error({
              title: 'Session expired',
              message: 'Please log in again.',
              duration: 10000
            })
            setTimeout(() => {
              unauthorizedNotifActive = false
            }, 10000)
          }
        }
      })
    })
  }
}
